import { useSelector } from 'react-redux';

export function useInvoiceMismatchChecks() {
  const {
    data: { invoiceItemData, invoiceGLItems },
  } = useSelector((state) => state.invoicing);
  const { invoice } = invoiceItemData || {};

  const totalSum = invoiceItemData?.invoiceItems?.reduce(
    (acc, item) => acc + item?.price * item?.quantity + item?.taxAmount,
    0
  );
  const calculatedTotal =
    invoiceGLItems?.length > 0
      ? invoiceGLItems.map((i) => Number(i.amount) + Number(i.shipping)).reduce((acc, cur) => acc + cur, 0) ?? 0
      : Math.round(((invoiceItemData?.invoice?.shipping ?? 0) + totalSum + Number.EPSILON) * 100) / 100;
  const glsShippingTotal =
    Math.round(
      ((invoiceGLItems?.map((i) => Number(i.shipping)).reduce((acc, cur) => acc + cur, 0) ?? 0) + Number.EPSILON) * 100
    ) / 100;
  const toDisplayedCents = (value) => Math.round((Number(value ?? 0) + Number.EPSILON) * 100);

  return {
    calculatedTotal,
    glsShippingTotal,
    totalMismatch:
      Math.abs(toDisplayedCents(invoice?.total) - toDisplayedCents(calculatedTotal)) >
      (invoiceItemData?.ignoreOneCentInvoiceGLVariance ? 1 : 0),
    shippingMismatch:
      invoice?.sourceMethod !== 'Manual' && invoiceGLItems?.length > 0 && glsShippingTotal !== invoice?.shipping,
    creditMemoMismatch: invoice?.invoiceType === 'CreditMemo' && calculatedTotal >= 0,
    invoiceTypeMismatch: invoice?.invoiceType !== 'CreditMemo' && calculatedTotal < 0,
  };
}